"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterType = exports.UsageTariffType = exports.UsageUnits = exports.UsagePeriod = exports.ReadQuality = void 0;
var ReadQuality;
(function (ReadQuality) {
    ReadQuality["ACTUAL"] = "ACTUAL";
    ReadQuality["ESTIMATE"] = "ESTIMATE";
    ReadQuality["MISSING"] = "MISSING";
})(ReadQuality = exports.ReadQuality || (exports.ReadQuality = {}));
var UsagePeriod;
(function (UsagePeriod) {
    UsagePeriod["YEARLY"] = "YEARLY";
    UsagePeriod["MONTHLY"] = "MONTHLY";
    UsagePeriod["DAILY"] = "DAILY";
    UsagePeriod["BILLINGPERIOD"] = "BILLINGPERIOD";
    UsagePeriod["TIMEPERIOD"] = "TIMEPERIOD";
})(UsagePeriod = exports.UsagePeriod || (exports.UsagePeriod = {}));
var UsageUnits;
(function (UsageUnits) {
    UsageUnits["KWH"] = "KWH";
    UsageUnits["MJ"] = "MJ";
})(UsageUnits = exports.UsageUnits || (exports.UsageUnits = {}));
var UsageTariffType;
(function (UsageTariffType) {
    UsageTariffType[UsageTariffType["UNKNOWN"] = 0] = "UNKNOWN";
    UsageTariffType[UsageTariffType["PEAK"] = 1] = "PEAK";
    UsageTariffType[UsageTariffType["OFFPEAK"] = 2] = "OFFPEAK";
    UsageTariffType[UsageTariffType["CONTROLLEDLOAD"] = 3] = "CONTROLLEDLOAD";
    UsageTariffType[UsageTariffType["DEMAND"] = 4] = "DEMAND";
    UsageTariffType[UsageTariffType["SHOULDER"] = 5] = "SHOULDER";
    UsageTariffType[UsageTariffType["SOLAR"] = 6] = "SOLAR";
    UsageTariffType[UsageTariffType["CONTROLLED"] = 7] = "CONTROLLED";
    UsageTariffType[UsageTariffType["ANYTIME"] = 8] = "ANYTIME";
    UsageTariffType[UsageTariffType["IMPORT"] = 9] = "IMPORT";
})(UsageTariffType = exports.UsageTariffType || (exports.UsageTariffType = {}));
var MeterType;
(function (MeterType) {
    MeterType["unknown"] = "unknown";
    MeterType["basic"] = "basic";
    MeterType["smart"] = "smart";
})(MeterType = exports.MeterType || (exports.MeterType = {}));
//# sourceMappingURL=usage.js.map